// CppSectionNav — left rail listing every section of a CPP/PCI record with
// derived numbering (from the backend "nav" array). Container headings are
// bold non-editable group labels; children are clickable and indented.
export default function CppSectionNav({ nav, sections, activeCode, onSelect }) {
    const isDone = (code) => {
        const s = sections.find((x) => x.code === code);
        if (!s) return false;
        if (s.not_applicable) return true;
        if ((s.fields || []).some((f) => f.value)) return true;
        if (s.narrative && s.narrative.trim()) return true;
        return false;
    };

    return (
        <nav className="w-64 shrink-0 space-y-0.5" data-testid="cpp-section-nav">
            {nav.map((n) => {
                if (n.code === "COVER" || n.code === "CONTENTS") return null;
                if (n.is_container) {
                    return (
                        <div key={n.code} className="pt-3 pb-1 px-2 text-[11px] font-bold uppercase tracking-wide text-[#9A968F]">
                            {n.number} {n.title}
                        </div>
                    );
                }
                const active = activeCode === n.code;
                const done = isDone(n.code);
                return (
                    <button key={n.code} data-testid={`cpp-nav-${n.code}`} onClick={() => onSelect(n.code)}
                        className={`w-full text-left flex items-center gap-2 px-2.5 py-1.5 rounded-lg text-[12.5px] ${n.depth > 0 ? "ml-2" : ""} ${active ? "font-semibold" : "text-[#4A4640] hover:bg-[#F5F3F0]"}`}
                        style={active ? { background: "#FBEFE5", color: "#9F4212" } : undefined}>
                        <span className={`w-1.5 h-1.5 rounded-full shrink-0 ${done ? "bg-[#3F7D3A]" : "bg-[#D8D3CB]"}`} />
                        <span className="text-[#9A968F] shrink-0">{n.number}</span>
                        <span className="truncate">{n.title}</span>
                        {n.not_applicable && <span className="text-[9px] text-[#9A968F] shrink-0">(N/A)</span>}
                    </button>
                );
            })}
        </nav>
    );
}
